import { Stack } from "@mui/material";

export const TechBadges = ({ items }: { items: string[] }) => (
  <Stack flexDirection="row" gap="8px" flexWrap="wrap">
    {items.map((tech) => (
      <Stack
        key={tech}
        alignItems="center"
        justifyContent="center"
        padding="6px 12px"
        borderRadius="6px"
        sx={{ backgroundColor: "#E8ECF0" }}
      >
        <span style={{ fontSize: "13px", fontWeight: 500 }}>{tech}</span>
      </Stack>
    ))}
  </Stack>
);
